<template>
  <div class="microbiology-main-view">
    <Microbiology />
  </div>
</template>

<script>
import Microbiology from './Microbiology.vue'

export default {
  name: 'MicrobiologyMainView',
  components: {
    Microbiology,
  },
}
</script>

<style lang="scss" scoped>
.microbiology-main-view {
  min-height: 100vh;
}
</style>
